import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice, createSelector } from "@reduxjs/toolkit";
import type { GetCustomFieldDefinitionsQuery } from "@/gql/graphql";

type CustomFieldDefinition =
  GetCustomFieldDefinitionsQuery["customFieldDefinitions"][number];

interface CustomFieldsState {
  loading: boolean;
  customFieldDefinitions: CustomFieldDefinition[];
}

const initialState: CustomFieldsState = {
  customFieldDefinitions: [],
  loading: false,
};

const customFieldsSlice = createSlice({
  name: "customFields",
  initialState,
  reducers: {
    setCustomFieldDefinitions: (
      state,
      action: PayloadAction<CustomFieldDefinition[]>,
    ) => {
      state.customFieldDefinitions = action.payload;
    },
    addCustomFieldDefinition: (
      state,
      action: PayloadAction<CustomFieldDefinition>,
    ) => {
      state.customFieldDefinitions.push(action.payload);
    },
    removeCustomFieldDefinition: (state, action: PayloadAction<string>) => {
      state.customFieldDefinitions = state.customFieldDefinitions.filter(
        (field) => field.id !== action.payload,
      );
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const {
  setCustomFieldDefinitions,
  addCustomFieldDefinition,
  removeCustomFieldDefinition,
  setLoading,
} = customFieldsSlice.actions;
export default customFieldsSlice.reducer;

interface RootState {
  customFields: CustomFieldsState;
}

export function selectCustomFieldsState(state: RootState): CustomFieldsState {
  return state.customFields;
}

export const selectCustomFieldDefinitions = createSelector(
  selectCustomFieldsState,
  (customFieldsState) => customFieldsState.customFieldDefinitions,
);

export const selectCustomFieldsLoading = createSelector(
  selectCustomFieldsState,
  (customFieldsState) => customFieldsState.loading,
);
